import {FC} from 'react';

interface Props {
  size?: number;
}

export const SvgIcon: FC<Props> = ({size = 64}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          fill="#FFF"
          d="M53.502 11.089V8H33.174v3.932H47.59L33.084 32.907v3.162h20.881v-3.895H38.971zM51.479 53.394c-.663.482-1.54.723-2.63.723-1.228 0-2.208-.286-2.941-.857a2.801 2.801 0 01-1.108-2.342h-1.186a3.83 3.83 0 00.641 2.187 4.166 4.166 0 001.88 1.484 6.86 6.86 0 002.723.53c1.445 0 2.61-.334 3.491-1.002a3.17 3.17 0 001.325-2.66 3.317 3.317 0 00-.49-1.821 4.09 4.09 0 00-1.464-1.325c-.653-.369-1.607-.726-2.862-1.07-1.254-.346-2.17-.743-2.744-1.193-.55-.41-.87-1.06-.857-1.746a2.239 2.239 0 01.955-1.876c.635-.48 1.489-.72 2.562-.721 1.105 0 1.986.292 2.64.876a2.94 2.94 0 01.98 2.315h1.194a3.948 3.948 0 00-.608-2.156 4.103 4.103 0 00-1.709-1.504 5.636 5.636 0 00-2.501-.539c-1.374 0-2.503.336-3.387 1.008a3.136 3.136 0 00-1.326 2.617c0 1.102.476 1.995 1.427 2.677.67.482 1.73.927 3.18 1.335 1.45.408 2.45.838 2.997 1.292a2.413 2.413 0 01-.172 3.762M42.232 40.89H31.43v1.002h4.8V54.92h1.185V41.899h4.809l.01-1.008zm-16.415 1.445l2.813 7.645h-5.626l2.813-7.645zm4.646 12.585h1.233l-5.31-14.03h-1.127l-5.31 14.03h1.244l1.445-3.942h6.369l1.456 3.942zm-12.716-7.716h-6.563v-5.293h7.498v-1.001H10v14.03h8.731v-1.002h-7.547v-5.724h6.563v-1.01z"
        />
        <path fill="#000" d="M10.092 19.728h16.401v3.724H10.092z" />
        <path
          fill="#FFF"
          d="M10.092 8.006h18.213v3.881H10.092zM10.092 32.274H28.44v3.793H10.092z"
        />
      </g>
    </svg>
  );
};

export default SvgIcon;
